// extracted by mini-css-extract-plugin
export var defaultWrapper = "_ht-3";
export var downloadButton = "_ht-4";
export var fileContainer = "_ht-9 _ht-7";
export var fileContainerBase = "_ht-7";
export var fileContainerBaseSm = "_ht-a _ht-7";
export var fileContainerFixedHeight = "_ht-8 _ht-7";
export var fileContainerFixedHeightSm = "_ht-c _ht-a _ht-7";
export var fileContainerSm = "_ht-b _ht-a _ht-7";
export var fileInfo = "_ht-5";
export var fileInfoWidthRestricted = "_ht-6";
export var fileType = "_ht-1";
export var fileTypeName = "_ht-2";
export var fileTypeSm = "_ht-d _ht-1";
export var image = "_ht-0";
export var link = "_ht-f";
export var overflowEllipsis = "_ht-e";